import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { sfx } from "@/lib/sound";

export default function RetroSkin({ onExit }) {
  const [left, setLeft] = useState(86);

  useEffect(() => {
    const iv = setInterval(() => setLeft((v) => v - 1), 1000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    if (left <= 0) onExit();
    else if (left <= 3) sfx.tick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left]);

  return createPortal(
    <>
      <div className="iv-crt-overlay" data-testid="retro86-overlay" />
      <motion.div
        className="iv-retro-hud"
        data-testid="retro86-hud"
        initial={{ y: -28, x: "-50%", opacity: 0 }}
        animate={{ y: 0, x: "-50%", opacity: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 24 }}
      >
        <span className="iv-retro-hud-label">RETRO-86 MODE</span>
        <span className="iv-retro-hud-time" data-testid="retro86-countdown">
          {String(Math.max(0, left)).padStart(2, "0")}s
        </span>
        <button type="button" className="iv-retro-hud-exit" data-testid="retro86-exit-btn" onClick={onExit}>
          EXIT
        </button>
      </motion.div>
    </>,
    document.body
  );
}
